var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#767676", fillRule: "evenodd", d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm-.5 9c.275 0 .5.112.5.25l.002.5c0 .138-.223.25-.5.25-.276 0-.5-.112-.5-.25L7 11.25c0-.138.223-.25.5-.25zm.2-7c1.873 0 3.3.758 3.3 2.5 0 .95-.602 1.559-1.678 2.093-.091.045-.974.445-1.111.532a.05.05 0 0 1-.012.006v.451a.5.5 0 0 1-1 0V9c0-.32.182-.533.477-.72.206-.13 1.17-.567 1.201-.583C9.647 7.316 10 6.957 10 6.5 10 5.481 9.094 5 7.7 5c-.673 0-1.242.361-1.474.914a.5.5 0 0 1-.922-.387C5.695 4.595 6.633 4 7.7 4z" })
  );
});